import Select from "react-select"
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { getDepartments } from '../../../../../MyApi/sb/departments';
import { getBranches } from '../../../../../MyApi/sb/branches';


const SubPayrollsFilter = ({
    branchId ,setSbDepartmentId ,setSbBranchId,setYears
}) => {
    const { t } = useTranslation();
    const page = 0;
    const DepartmentsQuery = useQuery(["getDepartments", page, branchId], () =>
      getDepartments(page, branchId)
    );
  
    const branchQuery = useQuery(["getbranches", page], () => getBranches(page));
    
  
    const branches = branchQuery.data?.data || [];
    const departments = DepartmentsQuery.data?.data || [];
   
 
  
    const handelBranchChange = (selectedBranch) => {
      const branchId = selectedBranch ? selectedBranch.id : 0;
      setSbBranchId(branchId);
    };
    const handleDepartmentsChange = (selectedDepartment) => {
      const departmentId = selectedDepartment ? selectedDepartment.id : 0;
      setSbDepartmentId(departmentId);
    };
    const handelYearsChange =(e)=>{
        setYears(e.target.value) 
    }
  return (
    <div className='card'>
        <div className='card-body'>
            <div className='row'>

            <div className="col-6 col-md">
          <label htmlFor="">{t("Branches")}</label>
          <Select
            type="text"
            name="branches"
            isClearable={true}
            onChange={handelBranchChange}
            options={branches}
            getOptionValue={(e) => e.id}
            getOptionLabel={(e) => e.name}
            placeholder="search"
          />
        </div>
        
        <div className="col-6 col-md">
          <label htmlFor="">{t("Departments")}</label>
          <Select
            type="text"
            name="departments"
            isClearable={true}
            onChange={handleDepartmentsChange}
            options={departments}
            getOptionValue={(e) => e.id}
            getOptionLabel={(e) => e.name}
            placeholder="search"
          />
        </div>

        <div className="col-6 col-md">
            <label htmlFor="">{t("Years")}</label>
        <select className="form-select">
            <option value="2024">2024</option>
        </select>
        </div>

            </div>

        </div>
        
    </div>
  )
}

export default SubPayrollsFilter